import { createFileRoute } from '@tanstack/react-router'
import { KycPage } from '@/features/kyc/pages/kyc-page'

export const Route = createFileRoute('/_authenticated/kyc')({
	component: KycPage,
})
